import { render, staticRenderFns } from "./pos-vendorStatement.vue?vue&type=template&id=7272a5b0"
import script from "./pos-vendorStatement.vue?vue&type=script&lang=js"
export * from "./pos-vendorStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports